import React, { useState, useEffect } from 'react'
import * as R from 'ramda'

import AudienceRuleAutoCompleteInput from '.'
import useAxios from 'hooks/useAxios'

/**
 *
 * @param {object} props
 * @param {string} props.field
 * @param {string} props.attribute
 * @param {string} props.defaultValue
 * @param {(event, data) => void} props.onChange
 * @param {boolean} [props.shouldAutoFocus]
 */
export default function AudienceRuleAutoCompleteInputContainer({
  field,
  attribute,
  defaultValue,
  onChange,
  shouldAutoFocus,
}) {
  const [autoCompleteQuery, setAutoCompleteQuery] = useState('')
  /** @type {[AutoCompleteApiResponse[], function]} */
  const [options, setOptions] = useState([])

  const { data, loading } = useAxios({
    method: 'post',
    url: 'reports/autocomplete/',
    data: {
      field: field === 'name' ? 'customer' : field === 'email' ? 'customer.email' : field,
      attribute,
      value: autoCompleteQuery,
    },
    skip: !field,
  })

  useEffect(() => {
    setOptions((options) => {
      const newOptions = createSemanticUiOptions(data, defaultValue, field)

      return deduplicateList('value', options.concat(newOptions))
    })
  }, [data, defaultValue, field])

  return (
    <AudienceRuleAutoCompleteInput
      options={options}
      defaultValue={defaultValue}
      onChange={onChange}
      onSearchChange={setAutoCompleteQuery}
      loading={loading}
      shouldAutoFocus={shouldAutoFocus}
    />
  )
}

/**
 * @typedef AutoCompleteApiResponse
 * @property {number} id
 * @property {string} label
 * @property {string} value
 * @param {AutoCompleteApiResponse[]} autoCompleteApiResponse
 * @param {string} [value]
 * @returns {import('semantic-ui-react').DropdownItemProps[]}
 */
function createSemanticUiOptions(autoCompleteApiResponse, value, field = null) {
  const options = R.pipe(
    R.defaultTo([]),
    R.map(({ id, label, value }) => {
      const val = field === 'name' ? label : value

      return {
        key: id,
        text: label,
        description: value === label ? null : value,
        value: val,
      }
    })
  )(autoCompleteApiResponse)

  if (!value) {
    return options
  }

  if (R.find(R.propEq('value', value), options)) {
    return options
  }

  return R.prepend({ text: value, value }, options)
}

function deduplicateList(propToDeduplicate, list) {
  return R.uniqBy(R.prop(propToDeduplicate), list)
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/AudienceRuleAutoCompleteInput/container.js